// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"fullscreen-exit"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10.5 19V13.5H5.00001M5 19L9.66655 14.3335M14.3335 9.66655L19 5M13.5 5.00001V10.5H19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-fullscreen-exit')
export default class FullscreenExitIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'fullscreen-exit',
    }
  }
}
